import { BankDefault } from 'assets/icons'
import Card from './Card'
import RoundedItem from './RoundedItem'

interface ContactCardProps {
  name?: string
  bankImages?: string[]
  className?: string
  onClick?: () => void
}

const ContactCard = ({
  name = '',
  bankImages = [],
  className = '',
  onClick = () => null
}: ContactCardProps) => (
  <button onClick={() => onClick()} className='w-full'>
    <Card className={`bg-white items-center flex p-3 gap-3 ${className}`}>
      <RoundedItem
        roundedIconClassName='!h-9 !w-9'
        hasTitle={false}
        name={name}
      />
      <div>
        <p className='font-bold text-back text-xs'>{name}</p>
        <div className='flex gap-1'>
          {bankImages.map((b, idx) =>
            b ? (
              <img
                key={`${b}${idx}`}
                className='rounded-full h-3 w-3'
                src={b}
                alt=''
              />
            ) : (
              <BankDefault className='rounded-full h-3 w-3' />
            )
          )}
        </div>
      </div>
    </Card>
  </button>
)

export default ContactCard
